import { MapState } from "./types";

export function getDefaultState(): MapState {
    return {
        markerContextMenuResponse: null,
        clusterContextMenuResponse: null,
        visibleMarkerKeysResponse: null,
        closeInfoWindow: false,
        plotItem: null,
    };
}
